<div class="modal fade" id="modalUserZaloDetail" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">THÔNG TIN CHI TIẾT</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-sm-12 d-flex">
                <div class="col-sm-8 d-flex flex-column user-left">
                    <div class="d-flex col-sm-12" v-for="item in userDetail" :key="item.key">
                        <div class="col-sm-5"><b>{{item.label}}:</b></div>
                        <template v-if="item.value && typeof item.value === 'object' && !Array.isArray(item.value)">
                            <div class="col-sm-12 d-flex flex-column">
                                <div class="col-sm-12 d-flex" v-for="(val, key) in item.value" :key="key">
                                    <div class="col-sm-4">{{val.label}}:</div>
                                    <div class="col-sm-6">{{val.value}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-sm-6">{{item.value}}</div>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 user-right">
                    <div><img :src="avatar" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</div>
